module.exports = __webpack_public_path__ + "static/media/Opening ceremonies.4b7efeec.png";